export default __webpack_public_path__ + "static/media/driver-license.f15f5e9d.svg";